import { render, staticRenderFns } from "./SupplierBbbee.vue?vue&type=template&id=78da9a30&scoped=true&"
import script from "./SupplierBbbee.vue?vue&type=script&lang=js&"
export * from "./SupplierBbbee.vue?vue&type=script&lang=js&"
import style0 from "./SupplierBbbee.vue?vue&type=style&index=0&id=78da9a30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78da9a30",
  null
  
)

export default component.exports